import { render, staticRenderFns } from "./Issue5.vue?vue&type=template&id=1cd4034f&scoped=true&"
var script = {}
import style0 from "./Issue5.vue?vue&type=style&index=0&id=1cd4034f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd4034f",
  null
  
)

export default component.exports